export default "__VITE_ASSET__D0XlVYqz__"